// Motifs de refus PREDEFINIS d'une participation campagne (Sound/PLV, lot 2026-08) :
// le pharmacien choisit un code parmi trois, plus aucune saisie libre. Les refus
// historiques restent stockes en texte brut et sont affiches tels quels.

export const PARTICIPATION_REJECT_REASONS = [
  'not_working_with_partner',
  'pharmacy_closed',
  'other',
] as const

export type ParticipationRejectReasonCode = (typeof PARTICIPATION_REJECT_REASONS)[number]

/**
 * Libelle d'un motif de refus : mappe les 3 codes vers l'i18n — le nom du labo est
 * injecte dans « Ne travaille pas avec {lab} » quand il est connu, sinon libelle
 * generique — et retombe sur le texte brut pour l'historique en saisie libre.
 */
export const formatRejectReason = (
  t: (key: any, params?: Record<string, unknown>) => string,
  reason: string | null | undefined,
  labName?: string | null
): string => {
  if (!reason) return ''
  switch (reason) {
    case 'not_working_with_partner':
      return labName
        ? t('components.participation.rejectReasonChoice.notWorkingWithPartner', { lab: labName })
        : t('components.participation.rejectReasonChoice.notWorkingWithPartnerGeneric')
    case 'pharmacy_closed':
      return t('components.participation.rejectReasonChoice.pharmacyClosed')
    case 'other':
      return t('components.participation.rejectReasonChoice.other')
    default:
      return reason
  }
}
